import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createSSRApp, h } from 'vue'
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { createPinia } from 'pinia'
import VueFeather from 'vue-feather';
// import { configureEcho } from "@laravel/echo-vue";
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
const vuetify = createVuetify()

const pinia = createPinia();

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const app=createInertiaApp({
    title: (title) => `${title} - Adam Wood`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        return createSSRApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(pinia)
            .use(vuetify)
            .component(VueFeather.name, VueFeather)

            .mount(el);
    },
    progress: {
        delay: 250,
        color: '#4B5563',
    },
});

// app.config.globalProperties.$route = route;

